import * as React from "react"
import {Form} from "semantic-ui-react"
import {BookerFragFragment, BookingGutsFragment} from "../graphql/queries"
import {history} from "../App"

interface Props {
  booking: BookingGutsFragment
  booker: BookerFragFragment
  disabled: boolean
}

export function BookingButtonsTop(props: Props) {
  const {booker, booking, disabled} = props
  const {isAdmin} = booker
  const isBooker = booking.booker && booking.booker.id === booker.id
  const showRepeat = isAdmin || isBooker
  const showReturn = isAdmin || isBooker

  function onRepeatBooking() {
    history.push("/booking/" + booking.number + "/repeat")
  }

  function onReturnBooking() {
    history.push("/booking/" + booking.number + "/return")
  }

  return showRepeat || showReturn ? (
    <Form.Group>
      {showRepeat && (
        <Form.Button
          positive
          compact
          disabled={disabled}
          onClick={(e) => {
            e.preventDefault()
            onRepeatBooking()
          }}
          content="Repeat booking"
        />
      )}
      {showReturn && (
        <Form.Button
          positive
          compact
          disabled={disabled}
          onClick={(e) => {
            e.preventDefault()
            onReturnBooking()
          }}
          content="Book return"
        />
      )}
    </Form.Group>
  ) : null
}



// WEBPACK FOOTER //
// ./src/components/BookingButtonsTop.tsx